"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPronunciationFeedback = getPronunciationFeedback;
function getPronunciationFeedback(word, settings) {
    if (word.verification?.excludedFromScore)
        return "ignored";
    if (word.textOffset !== undefined && word.verification) {
        const status = word.verification.status;
        if (status === "different" ||
            status === "missing" ||
            status === "uncertain")
            return status;
        return word.phonemes.some((phoneme) => Boolean(phoneme.name) &&
            phoneme.accuracy < settings.phonemeAttentionAccuracy)
            ? "sound"
            : "matched";
    }
    if (word.verification?.status === "different")
        return "different";
    if (word.verification?.status === "missing" || word.errorType === "Omission")
        return "missing";
    if (word.errorType === "Mispronunciation" ||
        word.accuracy < settings.mediumAccuracy)
        return "pronunciation";
    if (word.phonemes.some((phoneme) => phoneme.accuracy < settings.phonemeAttentionAccuracy))
        return "sound";
    if (word.verification?.status !== "matched")
        return "uncertain";
    return word.accuracy < settings.goodAccuracy ? "pronunciation" : "matched";
}
//# sourceMappingURL=pronunciationFeedback.js.map